import { api } from './api';
const list = (input) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/proposals'}, input);
}

export const proposalService = {
	list
};